import { render, staticRenderFns } from "./CityComponent.vue?vue&type=template&id=28ed16a8&"
import script from "./CityComponent.vue?vue&type=script&lang=js&"
export * from "./CityComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports